// extracted by mini-css-extract-plugin
module.exports =  {"container":"T9MSUt7","divider":"Uk0JDFP"};